import * as React from 'react'
import type { SVGProps } from 'react'
const SvgGoogleColored = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#4285F4"
      d="M22.5018 12.2331c0-.8633-.0715-1.4933-.2262-2.1467H12.2161v3.8966h5.9047c-.119.9684-.7619 2.4267-2.1905 3.4067l-.02.1305 3.1806 2.4147.2204.0215c2.0238-1.8317 3.1905-4.5267 3.1905-7.7233"
    />
    <path
      fill="#34A853"
      d="M12.2144 22.5001c2.8928 0 5.3213-.9334 7.0952-2.5434l-3.381-2.5667c-.9047.6183-2.119 1.05-3.7142 1.05-2.8333 0-5.238-1.8317-6.0953-4.3633l-.1257.0104-3.3072 2.5084-.0433.1178c1.762 3.43 5.381 5.7868 9.5715 5.7868"
    />
    <path
      fill="#FBBC05"
      d="M6.1197 14.0767c-.2262-.6533-.3571-1.3534-.3571-2.0767s.1309-1.4233.3452-2.0766l-.006-.1392L2.753 7.2356l-.1096.051C1.9173 8.71 1.5007 10.3085 1.5007 12s.4166 3.29 1.1428 4.7133z"
    />
    <path
      fill="#EB4335"
      d="M12.2144 5.56c2.0119 0 3.369.8516 4.1429 1.5634L19.3811 4.23C17.524 2.5383 15.1072 1.5 12.2144 1.5c-4.1905 0-7.8096 2.3567-9.5715 5.7866l3.4643 2.6367C6.9764 7.3917 9.3811 5.56 12.2144 5.56"
    />
  </svg>
)
export default SvgGoogleColored
